module.exports = __webpack_public_path__ + "img/btn-on.13d17607.png";